import React from "react";
import { cn } from "@gettactic/helpers";

const classes = {
  H1: "text-[36px] leading-[109%] font-[600] tracking-[0] text-ink",
  H2: "text-[24px] leading-[109%] font-[600] tracking-[0] text-ink",
  H3: "text-[18px] leading-[109%] font-[600] tracking-[0] text-ink",
  H4: "text-[16px] leading-[109%] font-[600] tracking-[0] text-ink",
  H5: "text-[14px] leading-[109%] font-[600] tracking-[0] text-ink",
  H6: "text-[12px] leading-[109%] font-[600] tracking-[0] text-ink",
  HeadingCard: "text-[18px] leading-[109%] font-[600] tracking-[0] text-ink"
};

export interface HeadingProps
  extends React.PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>> {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "card";
}

/** The type scale of each level, for text that looks like a heading but is not one. */
export const headingClasses = {
  h1: classes.H1,
  h2: classes.H2,
  h3: classes.H3,
  h4: classes.H4,
  h5: classes.H5,
  h6: classes.H6,
  card: classes.HeadingCard
};

/**
 * A title in the Tactic type scale (h1 36px to h6 12px, semibold), rendered as the matching
 * heading element. `as="card"` is a card title, an `h3`.
 */
export const Heading: React.FC<HeadingProps> = ({ as, children, ...rest }) => {
  const level = as || "h1";
  const className = headingClasses[level];
  // The real heading element, so it is a heading for assistive tech too
  const Tag = level === "card" ? "h3" : level;

  return (
    <Tag {...rest} className={cn(className, rest.className)}>
      {children}
    </Tag>
  );
};
